import LoginLayout from '../../components/layout/login/Login.layout';
import LicenceFeature from '../../components/features/auth/Licence';

const Licence = () => (
  <LoginLayout eyebrow="SeeWard appliance" title="Licence">
    <LicenceFeature />
  </LoginLayout>
);

export default Licence;
